import {Dayjs} from "@dracul/dayjs-frontend";

export default {
    methods: {
        getHour() {
            return Dayjs().format("HH:mm")
        },
        getDayOfWeek() {
            return Dayjs().day()
        },
        addExtendedTime(hour, extendedTime = 0) {
            let rHour = Dayjs(hour, "HH:mm").add(extendedTime, 'minute')
            return rHour.format("HH:mm")
        },
        calendarIsActive(calendar, dateHour, dayOfWeek, extendedTime = 0) {

            if (!dateHour) {
                dateHour = Dayjs()
            }

            if (!dayOfWeek) {
                dayOfWeek = this.getDayOfWeek()
            }

            let result = false

            if (calendar.schedule && calendar.schedule.length > 0) {
                calendar.schedule.forEach(schedule => {

                    if (schedule.dayOfWeek == dayOfWeek) {

                        schedule.activeHours.forEach(activeHours => {
                            let activeHoursFrom = Dayjs(activeHours.from, "HH:mm")

                            let activeHoursTo = Dayjs(activeHours.to, "HH:mm").add(extendedTime, 'minute')

                            if (activeHoursFrom.isBefore(dateHour)  && activeHoursTo.isAfter(dateHour)) {
                                result = true
                            }

                        })

                    }

                })

            }

            return result
        }
    }
}
